import React from "react";
import FAQAccordion from "../../../../utility/FAQAccordion";
import ShareButtons from "../../../../utility/ShareButtons";
import useServiceData from "../../../../utility/useServiceData";
import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../../utility/serviceTemplateutility/CardDesign";
import ListDesign from "../../../../utility/serviceTemplateutility/ListDesign";
import Slider from "react-slick";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import OurTeam from "../../../homepage/OurTeam";
import Testimonials from "../../../homepage/Testimonials";
import { useGlobalData } from "../../../../contextApi/globalContextData";
import { useCart } from "../../../../contextApi/cartContext";
import { useLanguage } from "../../../../contextApi/languageContext";
import { weightlossIV } from "../../../../text-files/weightloss&slimming/wieghtloss/weightlossIV.ts";
import { motion } from "framer-motion";
import BeforeAfterCarousel from "../../../../utility/serviceTemplateutility/BeforeAfterCarousel.jsx";

export default function WeightLossIV() {
  const serviceUrl = window.location.href;
  const data = useServiceData("Weight Loss IV");
  const { sectionsData } = useGlobalData();
  const imageUrl = data?.image_url;

  const { addToCart } = useCart();
  const { language } = useLanguage();
  const content = weightlossIV[language];
  const shared = weightlossIV.shared;

  const product = {
    id: 1,
    title: "Weight Loss IV Drip in Dubai",
    price: 1999,
    description:
      "Weight Loss IV Drip in Dubai boosts metabolism, burns fat, increases energy, and supports detox for safe, effective slimming results.",
  };

  const weightLossInjections = [
    { heading: "Weight Loss Injections For Your Transformation" },
    {
      title: "Fat Burning Injections",
      icon: "fa-solid fa-fire-flame-curved",
      description:
        "Fat loss injections work on unacceptable fat of the body like belly, thighs, and arms. They increase metabolism and help dissolve fat cells, which are then flushed from the body.",
    },
    {
      title: "Aqualyx Fat Dissolving",
      icon: "fa-solid fa-vial",
      description:
        "Aqualyx shots are a non-invasive treatment to help dissolve pockets of fat in areas like the chin, thighs, and stomach. It contains deoxycholic acid, which destroys fat cells to create a more sculpted look.",
    },
    {
      title: "Lipotropic Injections",
      icon: "fa-solid fa-capsules",
      description:
        "Lipotropic injections are composed of vitamins and nutrients essential to fat metabolism, liver function, and energy. This allows the body to efficiently use fat to burn it and also preserve lean muscle mass during weight loss.",
    },
    {
      title: "Mounjaro Injection",
      icon: "fa-solid fa-syringe",
      description:
        "Mounjaro injects into the body to help control blood sugar and encourage weight loss by suppressing appetite and invigorating metabolism. It’s intended for people with obesity or those with weight-related problems.",
    },
    {
      title: "Ozempic Injection",
      icon: "fa-solid fa-prescription-bottle-medical",
      description:
        "Ozempic is a prescription medication used by adults with type 2 diabetes to control blood sugar. It supports healthy metabolism and appetite, helping maintain a healthy weight. It works by imitating the hormone GLP-1.",
    },
    {
      title: "Weight Loss Injections",
      icon: "fa-solid fa-weight-scale",
      description:
        "These weight loss injections can greatly assist and help you lose weight very fast by stimulating metabolism, reducing hunger, increasing fat burning, and supporting the body's natural processes.",
    },
  ];

  const fatBurningBenefits = [
    { heading: "Benefits" },
    {
      para: "We are going to take a closer look at its benefits, and why the Weight Loss IV Drip can complement your diet and exercise plans.",
    },
    {
      title: "Accelerated Fat Burning",
      icon: "fa-solid fa-bolt",
      description:
        "It is through lipotropic agents that assist in breaking down fat deposits in the liver and encourage fat metabolism.",
    },
    {
      title: "Boosts Metabolism",
      icon: "fa-solid fa-fire",
      description:
        "It helps your body torch more fat, allowing you to lose excess weight at a faster rate.",
    },
    {
      title: "Improved Energy",
      icon: "fa-solid fa-battery-full",
      description:
        "Vitamins, such as B12, prevent fatigue and help keep you energized and motivated.",
    },
    {
      title: "Enhanced Hydration",
      icon: "fa-solid fa-droplet",
      description:
        "It also helps digest food, absorb nutrients, and maintain proper function during weight loss.",
    },
    {
      title: "Detoxification",
      icon: "fa-solid fa-recycle",
      description:
        "Certain IV drips also use antioxidants to aid the expulsion of toxins and improve liver function, supporting fat breakdown.",
    },
    {
      title: "Minimal Side Effects",
      icon: "fa-solid fa-shield-heart",
      description:
        "Because the ingredients are naturally occurring in the body, side effects are uncommon and limited.",
    },
  ];

  const eligibility = [
    { heading: "Eligibility" },
    {
      para: "The Weight Loss IV Drip is ideal for anyone who needs to boost their weight loss journey or to kick start a plateau when other methods aren’t working.",
    },
    {
      title: "Individuals fighting against stubborn fat",
      description:
        "If you’ve already been dieting and exercising, but don’t see the results you’d like, this treatment can help speed up and get you to your goals.",
      icon: "fa-solid fa-weight-hanging",
    },
    {
      title: "Sluggish Metabolisms",
      description:
        "Slow metabolism makes it difficult to lose weight. The metabolism-boosting compounds found in the IV drip can jumpstart your body's fat-burning mechanisms.",
      icon: "fa-solid fa-fire",
    },
    {
      title: "Busy professionals",
      description:
        "Even those who lead a busy lifestyle and have a difficult time preserving energy for workouts, can benefit from the drip of IV drip.",
      icon: "fa-solid fa-briefcase",
    },
    {
      title: "Everyone looking for a natural remedy",
      description:
        "IV drips are composed of vitamins and nutrients that are naturally occurring in the body, making them far safer for the average person.",
      icon: "fa-solid fa-leaf",
    },
  ];

  const preparing = [
    { heading: "Preparing" },
    {
      para: "Prior to embarking on Weight Loss IV Drip therapy, there are some preparatory steps to take to maximise the benefits of the treatment.",
    },
    {
      title: "Consultation",
      description:
        "You will speak to a healthcare provider about your goals for weight loss, your medical history, and your current state of health.",
      icon: "fa-solid fa-user-md",
    },
    {
      title: "Lab Tests",
      description:
        "Your culture involves working with you to determine if lab work is needed to help assess your overall health and see if there are any nutrient deficiencies that may be interfering with your weight loss.",
      icon: "fa-solid fa-flask",
    },
    {
      title: "Hydration",
      description:
        "Although the IV drip contains fluids to hydrate you, it’s still important to drink a lot of water before your session.",
      icon: "fa-solid fa-tint",
    },
    {
      title: "Avoid Heavy Meals",
      description:
        "Avoid a full meal before the therapy to minimize discomfort during the treatment.",
      icon: "fa-solid fa-utensils",
    },
    {
      title: "Relax",
      description:
        "Expect to recline and unwind through the 30–45 minute session. Most clinics provide a friendly atmosphere to make you feel comfortable.",
      icon: "fa-solid fa-bed",
    },
  ];

  const results = [
    { heading: "Results" },
    {
      para: "Results from Weight Loss IV Drip therapy can differ depending on your metabolic rate, initial weight, and health condition. But the majority of patients experience some form of the below",
    },
    {
      title: "Increased Energy",
      description:
        "Many feel an immediate boost in energy levels, which supports better physical activity and calorie burning.",
      icon: "fa-solid fa-bolt",
    },
    {
      title: "Accelerated Fat Loss",
      description:
        "Over time, the drip helps enhance your body’s ability to burn fat, leading to noticeable weight loss.",
      icon: "fa-solid fa-fire",
    },
    {
      title: "Improved Mood & Mental Clarity",
      description:
        "The vitamins and nutrients in the IV drip can also improve brain function, reducing stress and making it easier to focus on your wellness goals.",
      icon: "fa-solid fa-brain",
    },
    {
      title: "Enhanced Hydration & Overall Health",
      description:
        "Proper hydration leads to better digestion, improved skin tone, and more efficient bodily functions, all contributing to overall well-being.",
      icon: "fa-solid fa-water",
    },
  ];

  const beforeAfterResults = [
    {
      image:
        "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/105.webp",
      alt: "Ozempic Injection in Dubai",
    },
    {
      image:
        "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/110.webp",
      alt: "Belly Fat Removal",
    },
    {
      image:
        "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Postnatal-Weight-Loss-3.webp",
      alt: "Postnatal Weight Loss",
    },
  ];

  const settings = {
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const faqs = [
    {
      heading:
        "So why you should choose Elite Body Home for Weight Loss IV Drip Dubai?",
    },
    {
      question: "Is the Weight Loss IV Drip painful?",
      answer:
        "The procedure is generally painless. Some patients may feel a slight prick when the IV is inserted, but the overall experience is comfortable.",
    },
    {
      question: "How often should I get the Weight Loss IV Drip?",
      answer:
        "This depends on your weight loss goals and how your body responds to the treatment. Some patients benefit from weekly sessions, while others may need fewer treatments.",
    },
    {
      question: "Are there any side effects?",
      answer:
        "Most patients experience little to no side effects. Mild discomfort at the injection site or slight fatigue post-treatment may occur but typically resolves quickly.",
    },
    {
      question: "How soon will I see results?",
      answer:
        "Many patients report feeling more energized immediately after the treatment. Weight loss results vary depending on diet, exercise, and the frequency of treatments, but most people notice changes within a few weeks.",
    },
  ];

  return (
    <>
      <title>Weight Loss IV Drip Dubai | Elite Body Home Polyclinic</title>
      <meta
        name="description"
        content="At Elite Body Home, our Weight Loss IV Drip is designed to help you shed excess weight while boosting your energy and metabolism. FREE Consultation."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/weight-loss-iv-drip-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Weight Loss IV Drip Dubai | Elite Body Home Polyclinic"
      />
      <meta
        property="og:description"
        content="At Elite Body Home, our Weight Loss IV Drip is designed to help you shed excess weight while boosting your energy and metabolism. FREE Consultation."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/weight-loss-iv-drip-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2024-12-30T10:04:59+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-100.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-100.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Weight Loss IV Drip" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Weight Loss IV Drip Dubai | Elite Body Home Polyclinic"
      />
      <meta
        name="twitter:description"
        content="At Elite Body Home, our Weight Loss IV Drip is designed to help you shed excess weight while boosting your energy and metabolism. FREE Consultation."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-100.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        {/* Hero Image Section */}
        {shared.images.main && (
          <section className="overflow-hidden ">
            <div className="position-relative mb-3">
              <img
                src={shared.images.main}
                alt="male energy Dubai"
                className="img-fluid w-100 rounded mt-2 "
                style={{
                  height: "500px",
                  objectFit: "cover",
                  objectPosition: "top",
                  border: "2px solid #c69933",
                  borderRadius: "100px",
                }}
              />
            </div>
          </section>
        )}

        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-1 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            {/* Main Content Column */}

            {/* Breadcrumbs */}
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>

            {/* Title Section */}
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>

            <QuickNavigation />

            {/* How It Works Section */}
            {content.howItWorks.title && (
              <motion.section className="my-5">
                <h2 className="h2 fw-bold mb-4 text-center">
                  {content.howItWorks.title}
                </h2>
                {content.howItWorks.description && (
                  <p className="text-muted text-center">
                    {content.howItWorks.description}
                  </p>
                )}
              </motion.section>
            )}

            {/* Introduction Image */}
            {shared.images.introductionImage && (
              <motion.div className="my-5">
                <div className="text-center">
                  <img
                    src={shared.images.introductionImage}
                    alt="fat freezing treatment dubai"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: "500px" }}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </motion.div>
            )}

            <section id="process" className="my-5">
              <ListDesign listitems={content.injectionList} />
            </section>

            {/* Process Section */}
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.ingredients} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.eligibility} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.preparationTips} />
            </section>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Before & After Section */}
            {shared.images.beforeAfter &&
              shared.images.beforeAfter.length > 0 && (
                <motion.section
                  className="my-5"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <BeforeAfterCarousel
                    language={language}
                    images={shared.images.beforeAfter}
                  />
                </motion.section>
              )}
            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
